<template>
    <div>
        <div class="row">
                <div class="col-md-4 mb-1">
                    <v-stats-box text="Alacak Toplam" variant="warning" icon="currency_lira" :value="stats.AlacakToplam" ></v-stats-box>
                </div>
                <div class="col-md-4 mb-1">
                    <v-stats-box text="Borç Toplam" variant="danger" icon="currency_lira" :value="stats.BorcToplam" ></v-stats-box>
                </div>
                <div class="col-md-4 mb-1">
                    <v-stats-box text="Bakiye Toplam" variant="success" icon="currency_lira" :value="stats.BakiyeToplam" ></v-stats-box>
                </div>
        </div>
        <b-card no-body>
            <v-table    ref="table"
                        :fields="fields"
                        :items-provider="provider"
                        :settings="false"
                        pagination="server"
                        :initial-per-page="100">
                        <template #additional-actions>
                            <h4 class="mb-0"><span class="text-muted">Cari:</span> {{ name }}</h4>
                        </template>
                    </v-table>
        </b-card>
    </div>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import NetsisAccountantApi from '@/api/netsis-accountant';
import VStatsBox from '@/components/VStatsBox.vue'
export default{
    components:{
        BCard,
        VStatsBox,
    },
    data(){
        return {
            stats:{
                AlacakToplam:null,
                BorcToplam:null,
                BakiyeToplam:null
            },
            code:this.$route.params?.code ? this.$route.params.code : null,
            name:this.$route.query?.c ? this.$route.query?.c : null,
            fields:[
                { name:"Belge No",key:'BelgeNo', tdClass:'text-nowrap',thClass:'w-6'},
                { name:"Tarih",key:'Tarih',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Vade Tarihi",key:'VadeTarihi',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Kalan Borç (TL)",key:'KalanBorcStr', tdClass:'text-nowrap text-right',thClass:'w-7',component:true, componentOptions:{ name:'cari/CustomerDebt' }, key:'KalanBorcStr', tdClass:'text-nowrap text-right'},
                { name:"Borç (TL)",key:'BorcStr', tdClass:'text-nowrap text-right',thClass:'w-7'},
                { name:"Alacak (TL)",key:'AlacakStr',thClass:'w-7', tdClass:'text-nowrap text-right', tdClass:'text-nowrap text-right'},
                { name:"Kapatılmış Tutar (TL)",key:'KapatilmisTutarStr',thClass:'w-7', tdClass:'text-nowrap text-right', component:true, componentOptions:{ name:'cari/CustomerCredit' }},
                { name:"Bakiye (TL)", component:true, componentOptions:{ name:'cari/CustomerBalance' }, key:'KumilatifBakiyeStr', tdClass:'text-nowrap text-right',thClass:'w-7'},
                { name:"Açıklama",key:'Aciklama',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Hareket Türü",key:'HareketTuru', tdClass:'text-nowrap',thClass:'w-16'},
            ]
        }
    },
    mounted(){
        this.getStats()
    },
    methods:{
        provider(data){
            return NetsisAccountantApi.Cari.Detail({CariCode:this.code,PaginationRequestModel:data})
        },
        getStats(){
            NetsisAccountantApi.Cari.Stats(this.code).then(res=>{
                this.stats.AlacakToplam=res.data.AlacakToplam
                this.stats.BorcToplam=res.data.BorcToplam
                this.stats.BakiyeToplam=res.data.BakiyeToplam
            })
        },  
    }
}
</script>